<template>
  <v-dialog attach v-model="dialog" persistent>
    <v-card class="pa-8">
      <v-card-title style="position: sticky; top: 0; z-index: 999; background: white; height: 100px;">
        <v-row>
          <v-col cols="12" class="text-h3">
            {{ data.text.title }}
          </v-col>
          <v-col cols="auto">
            <v-btn class="ma-2" text icon top right absolute large @click="close(false)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <freeCodeCampCertifications v-if="data.id==='freeCodeCamp_Certifications'" />
            <photosNorway v-if="data.id==='photography_Norway'" />
            <photosBolivia v-if="data.id==='photography_Bolivia'" />
            <photosEngland v-if="data.id==='photography_England'" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import freeCodeCampCertifications from '@/views/home/articles/FreeCodeCamp'
import photosNorway from '@/views/home/articles/PhotosNorway'
import photosBolivia from '@/views/home/articles/PhotosBolivia'
import photosEngland from '@/views/home/articles/PhotosEngland'

export default {
  components: {
    freeCodeCampCertifications,
    photosNorway,
    photosBolivia,
    photosEngland
  },

  computed: {
    ...mapGetters({
      dialog: 'portfolioDialog',
      data: 'portfolioData'
    })
  },

  methods: {
    ...mapMutations({
      close: 'SET_PORTFOLIO_DIALOG'
    })
  }
}
</script>

<style>

</style>